import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=7b8b8f56&"
import script from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=7b8b8f56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports